<template>
  <tr>
    <th>
      {{ specialtyData.specialty_id }}
    </th>
    <td>
      <div>{{ specialtyData.name }}</div>
    </td>
    <td>
      <div class="is-flex is-justify-content-start" style="gap: 1em;">
        <div>
          <button class="button is-success is-small"  @click="emit('showSpecialtyData', specialtyData)">{{ $t('General.Details') }}</button>
        </div>
        <div v-if="getEditingMode">
          <button class="button is-danger is-small" @click="emit('removeSpecialty', specialtyData)">{{ $t('General.Delete') }}</button>
        </div>
      </div>
    </td>
  </tr>
</template>

<script lang="ts">
import { defineComponent, defineProps } from 'vue'
import { Notyf } from "notyf";

const notyf = new Notyf()

export default defineComponent({
  name: "SpecialtyTableRow"
})
</script>
<script lang="ts" setup>
import { useStore } from "vuex";
import { onMounted} from "vue";

interface SpecialtyData {
  specialty_id: number;
  name: string;
}

//Vue 3 version;
const props = defineProps<{
  specialtyData: SpecialtyData;
  getEditingMode: boolean;
}>();

const emit = defineEmits<{
  (e: 'showSpecialtyData', data: SpecialtyData): void;
  (e: 'removeSpecialty', data: SpecialtyData): void;
}>();

console.log('[Child] specialtyData received:', props.specialtyData);

//const props = defineProps(['specialtyData', 'parentShowSpecialtyData'])
const store = useStore()

/*
const remove = async (specialtyData: any, $t: any) => {
  if (confirm($t && $t('SpecialtyData.ConfirmDelete'))) {
    //TODO:Create notification to ask if it is really to delete
    try {
      await store.dispatch('deleteSpecialty', specialtyData)
      notyf.success($t('SpecialtyData.NotyfSpecialtyRemoved'))
    } catch (e) {
      notyf.error($t('SpecialtyData.NotyfErrorRemoveSpecialty'))
    }
  }
}*/

onMounted(() => {

})
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
</style>
